module.exports = __webpack_public_path__ + "img/titles.dc1639bb.png";